import { c as _c } from "react/compiler-runtime";
import { WithChildrenCommonProps } from '@types';
import { getOptionListHeaderStylesAsClassName } from './option-list-header-styles';
import { Typography } from '@components/typography';
export const OptionListHeader = t0 => {
  const $ = _c(7);
  let children;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = rest;
  } else {
    children = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getOptionListHeaderStylesAsClassName();
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== rest) {
    t2 = <Typography component="div" className={t1} variant="body2" {...rest}>{children}</Typography>;
    $[4] = children;
    $[5] = rest;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};